import React, { useEffect, useState } from "react";
import { message, Modal } from "antd";
import Empty from "../Components/Empty";
import NoticeItem from "./components/NoticeItem";
import { errorMessage } from "../../../Utils/useRequest";
import usePromiseCallback from "Utils/usePromiseCallback";
import LoadMore from "../../../components/LoadMore";
import {
    getNoticeList,
    NoticeListItem,
    markRead,
    clearRead,
    setSingleRead
} from "API";
import { NoticeToolBar } from "../Components/NoticeToolBar";
import { NoticeLayout } from "../Components/NoticeLayout";
import { NoticeCountAtom } from "../../../Stores/CommonStore";
import { useAtomValue } from "jotai";
import { useUpdateNoticeCount } from "Utils/useUpdateNoticeCount";

const PageNoticeList = () => {
    const pageSize = 20;
    const [readFlag, setReadFlag] = useState<number>(0); //1:显示未读 0：显示全部
    const [pageNo, setPageNo] = useState<number>(1);
    const [list, setList] = useState<NoticeListItem[]>([]);
    const [hasMore, setHasMore] = useState(false); // 是否还有下一页
    const [currentId, setCurrentId] = useState(0); // 当前展开的

    const unreadNum = useAtomValue(NoticeCountAtom);

    const updateCount = useUpdateNoticeCount();

    useEffect(() => {
        //获取公告列表
        loadData(pageSize, pageNo, readFlag);
        //获取未读消息个数
        updateCount();
    }, [readFlag]);

    // 加载更多
    const loadMore = usePromiseCallback(async () => {
        const newPage = pageNo + 1;
        await loadData(pageSize, newPage, readFlag);
        setPageNo(newPage);
    });

    // 加载数据
    const loadData = (pageSize: number, pageNo: number, readFlag: number) => {
        return getNoticeList(pageSize, pageNo, readFlag).then((res: any) => {
            setList(list => {
                return list.concat(res?.data?.data?.list || []);
            });
            setHasMore(res.data.data.count / pageSize > pageNo);
        });
    };

    //仅查看未读消息
    const viewUnread = (e: any) => {
        setList([]);
        setPageNo(1);
        setReadFlag(e.target.checked ? 1 : 0);
    };

    //获取未读消息条数

    //全部标记已读
    const markReadAll = () => {
        Modal.confirm({
            icon: "exclamation-circle",
            title: "确定把未读的通知设为已读吗?",
            onOk: async () => {
                try {
                    await markRead();
                    message.config({ top: 80 });
                    message.success("已全部标记为已读");
                    updateCount();
                    readFlag
                        ? setList([])
                        : setList(
                              list.map(item => ({ ...item, readStatus: "1" }))
                          );
                    if (readFlag) {
                        setHasMore(false);
                    }
                    return;
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    };

    //清空已读
    const clearReadAll = () => {
        Modal.confirm({
            icon: "exclamation-circle",
            title: "确定清空已读的通知吗？",
            onOk: async () => {
                try {
                    await clearRead();
                    message.config({ top: 80 });
                    message.success("已读通知已全部清空");
                    setList(list.filter(item => item.readStatus === "0"));
                    const isClear = list.every(item => item.readStatus === "1");
                    if (isClear) {
                        setHasMore(false);
                    }
                    return;
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    };

    const onclickItem = (id: number) => {
        setCurrentId(currentId === id ? 0 : id);
        const newList = list.map(item => ({
            ...item,
            readStatus: item.id === id ? "1" : item.readStatus
        }));
        setList(newList);

        setSingleRead(String(id)).then(res => {
            updateCount();
        });
    };

    return (
        <NoticeLayout tab="notice">
            <NoticeToolBar
                viewUnread={viewUnread}
                clearReadAll={clearReadAll}
                markReadAll={markReadAll}
                unreadNum={unreadNum}
            />

            <div>
                {list.length <= 0 ? (
                    <Empty />
                ) : (
                    list.map(item => (
                        <NoticeItem
                            key={item.id}
                            data={item}
                            onClick={() => onclickItem(item.id)}
                            active={currentId === item.id}
                        />
                    ))
                )}
                <LoadMore onVisible={loadMore} hasMore={hasMore} />
            </div>
        </NoticeLayout>
    );
};

export default PageNoticeList;
